export const ACTIVITIES_CATEGORIES = {
  PHONOLOGICAL_PROCESSES: "Phonological Processes",
  ARTICULATION: "Articulation",
  MORPHOSYNTAX: "Morphosyntax/Parts of Speech",
  VOCABULARY: "Vocabulary",
  COMPREHENSION: "Comprehension",
  FOLLOWING_DIRECTIONS: "Following Directions",
  SENTENCE_CONSTRUCTION: "Sentence Construction",
  NARRATIVE_SKILLS: "Sequencing/Narrative Skills",
  READING: "Reading",
  WRITING: "Writing",
  /* FLUENCY : 'Fluency', will be added back when we will have games in this category  */
  SOCIAL_LANGUAGE: "Social Language",
  BILINGUAL: "Preliteracy Awareness",
  REINFORCER_GAMES: "Reinforcer Games",
};

export const POPPINS_ACTIVITIES_CATEGORIES = {
  TIKSHORET: "הפרעות בתקשורת",
  EISUK: "ריפוי בעיסוק",
  RIGHSHI: "רגשי",
  PHYSIOTHERAPY: "פיזיותרפיה",
};

export const VIDEO_SESSION_PAGES = {
  SESSION_START: "SESSION_START",
  VIDEO: "VIDEO",
  SCREENSHARE: "SCREENSHARE",
  ACTIVITY: "ACTIVITY",
  TOOLS: "TOOLS",
  TEST: "TEST",
  YOUTUBE: "YouTube",
  WHITEBOARD: "Whiteboard",
  GAME: "Game",
  SESSION_END: "SESSION_END",
  VOCABULARY: "VOCABULARY",
  SESSION_CLEAR: "SESSION_CLEAR",
  SELF_PRACTICE: "SELF_PRACTICE",
};
